<template>
  <div>
    <template v-if="!isRedirecting">
      <PageTitle tag="h1" class="mb-7">
        {{ $t('employerRegistration') }}
      </PageTitle>

      <VRow>
        <VCol
          cols="12"
          sm="8"
          md="6"
          lg="4"
          class="mx-auto mb"
        >
          <RegistrationForm
            :company="company"
            :user="user"
            :action="registerAction"
            @registered="registered"
          />
        </VCol>
      </VRow>
    </template>
  </div>
</template>

<script>
import RegistrationForm from '@/forms/RegistrationForm';
import ValidationMixin from '../mixins/ValidationMixin';
import RecaptchaMixin from '../mixins/RecaptchaMixin';
import PageTitle from '../components/PageTitle.vue';
import Company from '../orm/models/Company/Company';
import User from '../orm/models/User/User';

export default {
  name: 'Registration',
  metaInfo() {
    return {
      title: this.$t('employerRegistration'),
    };
  },
  components: {
    PageTitle,
    RegistrationForm,
  },
  mixins: [ValidationMixin, RecaptchaMixin],
  title() {
    return this.$t('employerRegistration');
  },
  data() {
    return {
      globalLoading: true,
      company: {
        name: null,
        site: null,
        countryId: null,
        test: false,
        partnerCode: null,
        invitedBy: null
      },
      user: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        password: null,
        passwordConfirmation: null,
      },
      accept: false,
      registerAction: Company.api().store,
      isRedirecting: false,
    };
  },
  computed: {
    authUser() {
      return User.getAuthUser();
    },
  },
  watch: {
    authUser(newValue) {
      if (newValue && !this.isRedirecting) {
        this.redirectToDashboard();
      }
    },
  },
  created() {
    this.setQaData();
    this.setPartnerCode();
  },
  methods: {
    async registered() {
      if (window?.dataLayer) {
        window.dataLayer.push({ event: 'reg_success' });
      }
      this.redirectToDashboard();
    },
    redirectToDashboard() {
      if (this.isRedirecting) {
        return;
      }
      this.isRedirecting = true;
      window.location.replace(this.$router.resolve({ name: 'dashboard' }).href);
    },
    setQaData() {
      const { qamode } = this.$route.query;
      if (qamode === 'true') {
        this.user.password = '12345678';
        this.user.passwordConfirmation = '12345678';
        this.user.email = '@huntica.works';
        this.company.test = true;
      }

      if (document.cookie.includes('referralCode')) {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('referralCode='));
        this.company.invitedBy = cookie ? Number(cookie.split('=')[1]) : null;
      }
    },
    setPartnerCode() {
      const { companyPartner } = this.$route.query;

      if (companyPartner && process.env.VUE_APP_DEV_TOOLS === 'true') {
        this.company.partnerCode = companyPartner;
      }
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  employerRegistration: Employer registration
</i18n>

<i18n locale="ru" lang="yaml">
  employerRegistration: Регистрация работодателя
</i18n>
